import { forwardRef, InjectionToken } from '@angular/core';
import { graphqlClientService } from './graphqlClient.service';
import { urlService } from './urlService.service';

export interface IUrlService extends urlService{}

export const UrlServiceToken = new InjectionToken<IUrlService>('urlService');

export const UrlServiceProvider = {
	provide: UrlServiceToken,
	useExisting: forwardRef(() => urlService)
};